import Head from "next/head";
import { useContext } from "react";
import TemplateContext from "@/context/Template/TemplateContext";

export const ServiceHead = () => {

    const dataContext = useContext(TemplateContext);
    const { content: formatContent, ...rest } = dataContext || {};

    const { meta = [], title = "" } = rest?.properties?.service;

    return (
        <Head>
            <title>{`${title?.replace(/\s*\|\s*Clarín\s*$/g, '')} | Clarín`}</title>
            {meta?.map((element, index) => (
                <meta key={`meta${index}`} {...element} />
            ))}
            <link rel="canonical" href={formatContent?.urlCanonical} />
            <meta name="robots" content="max-image-preview:large"></meta>
        </Head>
    )
};